export enum StatementType {
  ConsolidatedStatement = 'consolidated_statement',
  FixedIncomeStatement = 'fixed_income_statement',
  IncomeStatement = 'income_statement',
  InvestmentReport = 'investment-report'
}
